import {
  parseCueIdentifier,
  type ParsedCueIdentifier,
  type PlanCode,
} from "./plan_label";

interface Cue {
  readonly id: string | null;
  /** VTT cue 本文（タイムライン表示用の一行） */
  readonly cueTitle: string;
  readonly planTags: readonly PlanCode[];
  /** `@` より前のパス（1要素）。ツリー構築用（`parseCueIdentifier` の結果を保持し再パースしない） */
  readonly idPathParts: readonly string[];
  readonly startTime: number;
  readonly endTime: number;
  readonly isHeading: boolean;
  /** 見出しのみ。識別子は `@` なしの数値（例: `3`）のためそのまま数値化 */
  readonly headingOrdinal: number | null;
}

const _headingOrdinalFromParsed = (parsed: ParsedCueIdentifier): number | null => {
  if (!parsed.isHeading) {
    return null;
  }
  const token = (parsed.idPathParts[0] ?? "").trim();
  const n = Number.parseInt(token, 10);
  return Number.isFinite(n) ? n : null;
};

const cueFromTextTrackCue = (raw: TextTrackCue, fallbackCueTitle: string): Cue => {
  const rawText =
    "text" in raw && typeof raw.text === "string" ? raw.text.trim() : "";
  const id = raw.id?.trim() ?? null;
  const cueTitle = rawText || fallbackCueTitle;
  const parsed = parseCueIdentifier(id);
  return {
    id,
    cueTitle,
    planTags: parsed.planTags,
    idPathParts: parsed.idPathParts,
    startTime: raw.startTime,
    endTime: raw.endTime,
    isHeading: parsed.isHeading,
    headingOrdinal: _headingOrdinalFromParsed(parsed),
  };
};

export { type Cue, cueFromTextTrackCue };
